import { render, staticRenderFns } from "./SubscriptionInfoForm.vue?vue&type=template&id=064f3e71&"
import script from "./SubscriptionInfoForm.vue?vue&type=script&lang=js&"
export * from "./SubscriptionInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionInfoForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports